import { render, staticRenderFns } from "./CtintRouterPageContent.vue?vue&type=template&id=643832e8&"
import script from "./CtintRouterPageContent.vue?vue&type=script&lang=js&"
export * from "./CtintRouterPageContent.vue?vue&type=script&lang=js&"
import style0 from "./CtintRouterPageContent.vue?vue&type=style&index=0&id=643832e8&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports